<div class="ui-g" [formGroup]="agreementPartnerDetailsForm">
  @if (loading) {
    <div class="loading-indicator">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <div class="pagehd ml-2 ui-g-12">Program Agreement Partner Details</div>

  <div class="ui-g workshop-header">
    <div class="ui-g-12 ui-md-12 ui-lg-12 title">Program type</div>
    <div class="ui-g-12 ui-md-3 ui-lg-3">
      <p-select
        panelStyleClass="notification-banner-programtype-dropdown"
        [options]="programtypes"
        placeholder="Select Program Type"
        optionLabel="programName"
        formControlName="partnerWorkshopType"
        optionValue="programTypeIDs"
        (onChange)="onProgramTypeChange($event)"></p-select>
    </div>
    <div class="ui-g-12 ui-md-12 ui-lg-12 title">Select Date</div>
    <div class="ui-g-12 ui-md-3 ui-lg-3">
      <p-datepicker
        formControlName="fromDate"
        dateFormat="mm/dd/yy"
        [maxDate]="maxDate"
        hourFormat="12"
        inputId="basic"
        [readonlyInput]="false"
        [iconDisplay]="'input'"
        [showIcon]="true"
        placeholder="Click to select date"></p-datepicker>
    </div>

    <div class="ui-g-12 ui-md-3 ui-lg-3 download-button">
      <button
        type="button"
        pButton
        class="banner-button-container ui-button-info"
        (click)="downloadPartnerDetails()"
        [disabled]="isButtonDisabled">
        Download Template
      </button>
    </div>
  </div>
  @if (isEmptyPartnerList) {
    <div class="ui-g-12 ui-md-12 ui-lg-12 title errorMessage workshop-header">
      {{ this.errorMessage }}
    </div>
  }
</div>
